import { TimePlot } from '../src/timeplot'
import { App, AudioSource } from '../src/data_source'

const N = 500;

const plot: TimePlot = new TimePlot("timeplot", document.getElementById("timeplot"), N, 2000, [-1.5,1.5]]);

const app = new App();
app.run(null, [plot]);
//
let x = 0;
let phase = 0;
function step(){
    x += 1;
    let data = [];
    for (let i = 0; i < N; i++){
      data.push(Math.sin(x/100 + i/N*2*Math.PI) + Math.random()*.25);
    }
    plot.update([data]);
}
setInterval(step, 5);
